import React, { useContext } from 'react';

import { LangContext } from 'providers/LangProvider';
import LangSwitch from '../LangSwitch';
import { Wrapper } from './styles';

const NavbarLinks = ({ desktop }) => {
  const { lang } = useContext(LangContext);

  // Includes the page path so the links also work from pages without these sections, like 404
  const translations = {
    is: [
      { href: '/#eigendur', text: 'Eigendur' },
      { href: '/#sogubrot', text: 'Sögubrot' },
      { href: '/#nu', text: 'Nú' },
    ],
    en: [
      { href: '/en/#owners', text: 'Owners' },
      { href: '/en/#history', text: 'History' },
      { href: '/en/#the-present', text: 'The Present' },
    ],
  };

  const currentTrans = translations[lang];

  // Scrolling to the sections is smooth and offset below the sticky header via CSS (see Layout/styles.js)
  return (
    <Wrapper desktop={desktop}>
      {currentTrans.map(trans => (
        <a key={trans.href} href={trans.href}>
          {trans.text}
        </a>
      ))}
      {/* On phones the language switch is in the header bar instead (see Header) */}
      {desktop && <LangSwitch />}
    </Wrapper>
  );
};

export default NavbarLinks;
